import * as PropTypes from "prop-types";
import classNames from "classnames";

import contentBoxStyles from "./ContentBox.css";

import {
  ButtonLink,
  ButtonLinkPropTypes,
  ButtonWithText,
  ButtonWithTextPropTypes,
  HeadingHeader,
  HeadingsPropTypes,
  TextCopy,
  TextNavTitle,
  TextsPropTypes,
} from "/react/library/";

export class ContentBox extends React.PureComponent {
  static propTypes = {
    alignsRight: PropTypes.bool,
    children: PropTypes.node.isRequired,
    hasMaxWidth: PropTypes.bool,
    hasVerticalPadding: PropTypes.bool,
    hasWideMaxWidth: PropTypes.bool,
  };

  render() {
    const {
      alignsRight,
      children,
      hasMaxWidth,
      hasVerticalPadding,
      hasWideMaxWidth,
    } = this.props;

    return (
      <div
        className={classNames(contentBoxStyles.contentBox, {
          [contentBoxStyles.contentBoxHasMaxWidth]: hasMaxWidth,
          [contentBoxStyles.contentBoxHasWideMaxWidth]: hasWideMaxWidth,
          [contentBoxStyles.contentBoxAlignsRight]: alignsRight,
          [contentBoxStyles.contentBoxHasVerticalPadding]: hasVerticalPadding,
        })}
      >
        {children}
      </div>
    );
  }
}

export class ContentBoxTitle extends React.PureComponent {
  // static propTypes = TextsPropTypes

  render() {
    const { className, ...restProps } = this.props;

    return <TextNavTitle {...restProps} className={className} />;
  }
}

export class ContentBoxHeader extends React.PureComponent {
  // static propTypes = HeadingsPropTypes;

  render() {
    const { className, ...restProps } = this.props;

    return (
      <HeadingHeader
        {...restProps}
        className={classNames(className, contentBoxStyles.topSpacingSm)}
      />
    );
  }
}

export class ContentBoxCopy extends React.PureComponent {
  // static propTypes = TextsPropTypes;

  render() {
    const { className, ...restProps } = this.props;

    return (
      <TextCopy
        {...restProps}
        className={classNames(className, contentBoxStyles.topSpacingMd)}
      />
    );
  }
}

export class ContentBoxButton extends React.PureComponent {
  // static propTypes = ButtonWithTextPropTypes;

  render() {
    const { className, ...restProps } = this.props;

    return (
      <ButtonWithText
        {...restProps}
        className={classNames(className, contentBoxStyles.topSpacingMd)}
      />
    );
  }
}

export class ContentBoxLink extends React.PureComponent {
  // static propTypes = ButtonLinkPropTypes;

  render() {
    const { className, ...restProps } = this.props;

    return (
      <ButtonLink
        {...restProps}
        className={classNames(className, contentBoxStyles.linkSpacingMd)}
      />
    );
  }
}

export class ContentBoxWrapper extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
  };

  render() {
    const { children, className } = this.props;

    return (
      <div className={classNames(className, contentBoxStyles.topSpacingMd)}>
        {children}
      </div>
    );
  }
}
